import { Component, Input, forwardRef } from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  ValidationErrors,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [
    CommonModule,
    InputWrapperComponent,
    InputTextModule,
    InputTextareaModule,
  ],
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() label2?: string;
  @Input() labelOnPress?: () => void;
  @Input() valueLabel?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;
  @Input() alt?: boolean;
  @Input() onPress?: () => void;
  @Input() disabled?: boolean;
  @Input() readonly?: boolean;
  @Input() type: 'text' | 'password' | 'number' | 'textarea' = 'text';
  @Input() placeholder?: string = '';
  @Input() resize?: boolean = true;

  @Input() leftIcon?: string;
  @Input() rightIcon?: string;

  value: any;

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleInputChange(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    this.value = target.value;
    this.onChange(this.value);
  }
}
